import '@styles/react-components/dealer-locator.css';
import React from 'react';
import ReactDOM from 'react-dom';
import DealerLocator from '@components/dealer-locator/DealerLocator';
import { matchWildcard } from './scripts/utility/strings';

const render = () => {
  var dealerLocatorWrappers = document.getElementsByClassName("ft-dealer-locator");

  for (var i = 0; i < dealerLocatorWrappers.length; i++) {
    ReactDOM.render(
        <DealerLocator {...dealerLocatorWrappers[i].dataset}/>
    , dealerLocatorWrappers[i])
  }
}

if(window.dealer_locator?.block_ips.length > 0) {
  fetch('https://api.ipify.org?format=json')
  .then(response => response.json())
  .then(data => {
    const match = window.dealer_locator.block_ips.find(ip => matchWildcard(data.ip, ip));
    if(match) {
      console.log('Blocked IP', data.ip, match);
      window.heap && window.heap?.track?.('Blocked IP', {ip: data.ip, match: match});
      return;
    }
    render();
  });
}else{
  render();
}